
export default function SettingsPage({ authUser }) {

    return (
        <div>Settings main</div>
    )
}